import { AddVehicleComponent } from './add-vehicle/add-vehicle.component';
import { CreateVehicleComponent } from './create-vehicle/create-vehicle.component';
import { EditvehicleComponent } from './editvehicle/editvehicle.component';
import { SingleVehicleViewComponet } from './view-vehicle/single-vehicle.component';
import { ViewVehicleComponent } from './view-vehicle/view-vehicle.component';
import {EventVehicleComponent} from './event-vehicle/event-vehicle.component';

export const VehicleRouting = [
    { path: '', redirectTo: 'view-vehicle', pathMatch: 'full' },
    // { path: '',component:ViewVehicleComponent },
    { path: 'add-vehicle', component: AddVehicleComponent},
    {path: 'create-vehicle', component: CreateVehicleComponent},
    {path: 'event-vehicle', component: EventVehicleComponent},
    { path: 'view-vehicle/:vendorID', component: ViewVehicleComponent},
    { path: 'single-view-vehicle/:vendorID/:vehicleID', component: SingleVehicleViewComponet},
    {path: 'edit-vehicle/:vendorID/:vehicleID', component: EditvehicleComponent},
    {path: 'vehicle-view/:vendorID/:vehicleID/:view', component: EditvehicleComponent}

];

export const VehicleRoutingBreadcrumbs = [
    // { name: 'View',path:'' },
    // { name: 'View',path:'/view-vehicle' },
    // { name: 'Single-view',path:'/single-view-vehicle' },
    // { name: 'Edit', path: '/edit-vehicle' },
    // { name: 'Add', path: '/create-vehicle' },

];